import { combineReducers } from 'redux';
import settings from './settings/reducer';
import { user } from "./user";

const reducers = combineReducers({ settings, 
    //general,
     user   });

export default reducers;